export default "/bundles/assets/scroll-left_a80d321e55b883446c4f77e9c2e5517f.png";